import { Group, Table, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconChevronUp, IconSelector } from '@tabler/icons-react';

export interface SortProps {
  sortBy: string;
  sortOrder: 'asc' | 'desc';
  onSort: (field: string) => void;
}

/** Column header that owns its field's sort state — modern list pattern
 * (the toolbar stays for filters only). */
export function SortableTh({
  label,
  field,
  sortBy,
  sortOrder,
  onSort,
}: Readonly<{ label: string; field: string } & SortProps>) {
  const active = sortBy === field;
  const Icon = active ? (sortOrder === 'desc' ? IconChevronDown : IconChevronUp) : IconSelector;
  return (
    <Table.Th aria-sort={active ? (sortOrder === 'desc' ? 'descending' : 'ascending') : 'none'}>
      <UnstyledButton onClick={() => onSort(field)} data-testid={`sort-${field}`}>
        <Group gap={4} wrap="nowrap">
          <Text size="sm" fw={700}>
            {label}
          </Text>
          <Icon size={14} style={{ opacity: active ? 1 : 0.4 }} />
        </Group>
      </UnstyledButton>
    </Table.Th>
  );
}
